import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
} from "antd";
import ActualDate from "./ActualDate";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import StAddNew from "../../pages/DSeries/StAddNew";

const { Text, Link } = Typography;

const EventDetail_Calibration = (props) => {
  const [visible, setVisible] = useState(false);
  const [actualDateDisplay, setActualDateDisplay] = useState(false);
  const [validationError, setValidationError] = useState({
    planError: null,
    actualError: null,
  });
  const [loginError, setLoginError] = useState(false);

  const [disabledBtn, setDisabledBtn] = useState(false);
  const [form] = Form.useForm();
  // const options = null;

  const checkFromAndToDateValidation = (fromDate, toDate) => {
    return toDate >= fromDate;
  };

  const handleChangeEvent = (e) => {
    const planFrom = form.getFieldValue("PlanSeriesFrom");
    const planTo = form.getFieldValue("PlanSeriesTo");
    const actualFrom = form.getFieldValue("ActualSeriesFrom");
    const actualTo = form.getFieldValue("ActualSeriesTo");

    let errorMsg = { planError: null, actualError: null };
    if (!checkFromAndToDateValidation(planFrom, planTo)) {
      errorMsg.planError = "`From Date` can't be greater then `To Date`";
    }
    if (
      actualFrom &&
      actualTo &&
      !checkFromAndToDateValidation(actualFrom, actualTo)
    ) {
      errorMsg.actualError = "`From Date` can't be greater then `To Date`";
    }
    setValidationError(errorMsg);
  };

  const handleCancel = (e) => {
    setVisible(false);
    setValidationError({ planError: null, actualError: null });
    props.modelCloseHandler();
  };

  useEffect(() => {
    if (props.visible) {
      setVisible(props.visible);
    }
    // if (props.data) {
    //   form.setFieldsValue(props.data);
    // }
  }, [props]);
  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        {props.visible ? (
          <Modal
            title={props.isEdit ? "Edit Event" : "Add Event"}
            open={visible}
            onOk={handleCancel}
            onCancel={handleCancel}
            className={"ThemeModal"}
            width={'40%'}
          >
            <StAddNew
              colSpan={24}
              extraData={{ eventTyp: props.isEdit ? 'event' : 'new', _id: props.data.itemid }}
              urlData={{ eventTyp: props.isEdit ? 'event' : 'new', _id: props.data.itemid, dtSel: props.data.dtSel, ...props.urlData }}
              urlEndpoint={"/calendarevent"}
              onCallFinish={({ data }) => {
                props.callback();
                handleCancel();
              }}
            />
          </Modal>
        ) : null}
      </React.Fragment>
    </>
  );
};

export default EventDetail_Calibration;
